module.exports = __webpack_public_path__ + "0fa624938161b646db2ba8e06189c9cf.png";